<template>
  <mega-menu />
</template>

<script>
import MegaMenu from './components/MegaMenu/MegaMenu'

export default {
  name: 'app_megaMenu',
  components: { MegaMenu },
  data: () => ({

  }),
  mounted () {

  }
}
</script>
<style lang="scss">
@import "assets/variables";

//.md-theme-default {
//  #content {
//    a:not(.md-button) {
//      color: $primaryColor;
//    }
//  }
//}
</style>
